import { render, staticRenderFns } from "./SupportTicketCreateForm.vue?vue&type=template&id=36362e48&"
import script from "./SupportTicketCreateForm.vue?vue&type=script&lang=js&"
export * from "./SupportTicketCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketCreateForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports